import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { formatDetail } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(email, password, name);
      toast.success("Awakening complete. Welcome, hunter.");
      nav("/");
    } catch (e) {
      toast.error(formatDetail(e.response?.data?.detail) || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden">
      <div className="noise-overlay" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-cyan-500/10 blur-[100px]" />

      <div className="relative z-10 w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="h-display text-3xl sm:text-4xl">
            Begin <span className="text-violet-400">Awakening</span>
          </h1>
          <p className="mt-2 text-sm text-slate-400">Register as an E-Rank Hunter</p>
        </div>

        <form onSubmit={submit} className="panel panel-corners p-6 space-y-4">
          <div>
            <label className="label-tech block mb-1.5">Hunter Name</label>
            <input
              data-testid="register-name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full bg-black/60 border border-white/10 focus:border-cyan-400/60 outline-none px-3 py-2.5 text-white font-mono-tech text-sm"
              placeholder="Sung Jin-Woo"
            />
          </div>
          <div>
            <label className="label-tech block mb-1.5">Hunter ID</label>
            <input
              data-testid="register-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-black/60 border border-white/10 focus:border-cyan-400/60 outline-none px-3 py-2.5 text-white font-mono-tech text-sm"
              placeholder="hunter@ascend.system"
            />
          </div>
          <div>
            <label className="label-tech block mb-1.5">Access Key</label>
            <input
              data-testid="register-password"
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-black/60 border border-white/10 focus:border-cyan-400/60 outline-none px-3 py-2.5 text-white font-mono-tech text-sm"
              placeholder="min. 6 characters"
            />
          </div>

          <button data-testid="register-submit" disabled={busy} type="submit" className="btn-neon w-full">
            {busy ? "Awakening..." : "Begin Ascend"}
          </button>

          <p className="text-center text-xs text-slate-400 pt-2">
            Already a hunter?{" "}
            <Link data-testid="link-login" to="/login" className="text-cyan-400 hover:text-cyan-300">
              Enter System
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
